import { observerSessionStarted, observerTakeExamReceived, setObserverSessionStarted } from "./observerActions"
import { startProctorioSession } from "./startProctorioSession"

export const startProctorioSessionOnce = () => {

  if (observerTakeExamReceived()) return
  if (observerSessionStarted()) return

  setObserverSessionStarted()
  startProctorioSession()
}
